export default __webpack_public_path__ + "static/media/SilentStar_120_Em_OrganSynth.f2d668af.mp3";